const CURVATURE_RADIUS_FACTOR = 1.2
const TOTAL_POINTS = 50
const LINE_CAP_RADIUS = 50

/**
 * Returns a curved line between two given points
 */
export default function getCurvedLineOverlays(
  mapkit,
  first: {lat?: number; lng?: number},
  second: {lat?: number; lng?: number},
  opts: {color?: string; width?: number} = {}
) {
  const {color = '#000'} = opts

  let pointA = first
  let pointB = second

  if (pointB.lng < pointA.lng) {
    pointA = second
    pointB = first
  }

  // Get a third coordinate point to use for the curve
  const a = pointB.lng - pointA.lng
  const b = pointB.lat - pointA.lat
  const linearDistance = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2))
  const middle = linearDistance / 2
  const triangleHeight = middle * CURVATURE_RADIUS_FACTOR
  const curvatureDeg = Math.atan(triangleHeight / middle)
  const triangleInclination = Math.atan(b / a)

  const side = middle / Math.cos(curvatureDeg)
  const x = pointA.lng + side * Math.sin(Math.PI / 2 - triangleInclination - curvatureDeg)
  const y = pointA.lat + side * Math.cos(Math.PI / 2 - triangleInclination - curvatureDeg)

  // Convert three points (triangle) to curve
  const points = []
  for (let i = 0; i < TOTAL_POINTS; i++) {
    const t = i / (TOTAL_POINTS - 1)
    const x1 = pointA.lng + (x - pointA.lng) * t
    const y1 = pointA.lat + (y - pointA.lat) * t
    const x2 = x + (pointB.lng - x) * t
    const y2 = y + (pointB.lat - y) * t
    const x3 = x1 + (x2 - x1) * t
    const y3 = y1 + (y2 - y1) * t
    points.push(new mapkit.Coordinate(y3, x3))
  }

  const coordinates = [
    new mapkit.Coordinate(pointA.lat, pointA.lng),
    ...points,
    new mapkit.Coordinate(pointB.lat, pointB.lng)
  ]

  const style = new mapkit.Style({
    strokeColor: color,
    lineWidth: opts.width || 2,
    lineCap: 'round',
    lineJoin: 'round'
  })

  const polyline = new mapkit.PolylineOverlay(coordinates, {style})
  const circle = new mapkit.CircleOverlay(
    new mapkit.Coordinate(second.lat, second.lng),
    LINE_CAP_RADIUS,
    {
      style: new mapkit.Style({
        fillColor: color,
        fillOpacity: 1,
        strokeColor: color
      })
    }
  )

  return [polyline, circle]
}
